module.exports = __webpack_public_path__ + "media/images/infinity-title-logo-9dad58219f1cf514f952891f3440aaec.png";